// extracted by mini-css-extract-plugin
export var consoleButton = "ConsoleButton-module--consoleButton--e4122";
export var link = "ConsoleButton-module--link--27595";